<app-customer-details [customer]="this.customer"></app-customer-details>
